<template>
    <div class="the-navbar__user-meta flex items-center" v-if="name">
        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ name }}</p>
            <small>{{ role }}</small> <!--role_id-->
        </div>

        <div class="con-img ml-3" v-if="!menu">
            <img v-if="photoURL" key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40"
                 class="rounded-full shadow-md cursor-pointer block"/>
        </div>

        <vs-dropdown v-else vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
                <img v-if="photoURL" key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40"
                     class="rounded-full shadow-md cursor-pointer block"/>
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 9rem">
                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        v-can="'user.autologin_linked_user'"
                        v-for="(user, index) of userState.linked_user_group || []"
                        :key="index"
                        @click="$emit('changeUser', user)"
                    >
                        <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">{{ user.name }}</span>
                    </li>

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        @click="$emit('logoutAction')">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">{{ $t('buttons.Logout') }}</span>
                    </li>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'

export default {
    props: {
        name: {
            type: String,
            required: true
        },

        role: {
            type: String,
            required: true
        },

        photoURL: {
            type: String,
        },

        logout: {
            type: Boolean
        },

        menu: {
            type: Boolean
        }
    },

    computed: {
        userState() {
            return this.$store.getters.userState
        }
    },

    async mounted() {
        try {

        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>
